import { apiClient } from "../api/apiClient.js";
import { CONFIG } from "../api/config.js";
import { network } from "../network.js";

import { getDefaultPlayer, getDefaultActions, getDefaultUIInfo } from "./defaultState.js";
import { tileHandler } from "../handlers/tileHandler.js";
import { soulHandler } from "../handlers/soulHandler.js";
import { spellHandler } from "../handlers/spellHandler.js";
import { huntingHandler } from "../handlers/huntingHandler.js";
import { worldHandler } from "../handlers/worldHandler.js";
//

export class gameState {
    constructor() {
        this.init();
    }

    init() {
        this.player = { //object containing player state
            stats: {
                magicPower: new Decimal(0)
            },
            elements: {
            },
            currentCultivationElement: null,
            currentFormationElement: null
        }; 
        
        this.actions = {
            meditation: {
                isActive: false,
                progress: 0,
                duration: 0,
                baseDuration: 0, 
                mpGain: new Decimal(0), //function call?      
            },
            awakening: {
                isActive: false,
                progress: 0,
                duration: 1000,
                baseDuration: 1000, 
                mpGain: 0, 
                targetElement: null 
            }, 
            cultivation: {
                
            }
        }

        this.isPlayerSaving = false;

        this.map = { //object containing map state
            gridSize: 5,
            centerX: 0,
            centerY: 0
        }; 


        this.uiInfo = {
            hasMoved: {
                hunting: true,
                quest: true
            },
            newElement: {
                formation: true,
                cultivation: true,
                spellbook: true,
            },
            currentCultivationMenu: "none",
            currentFormationMenu: "none",
            currentSpellbookMenu: "none",
            newShard: true,
            updateHuntingSubmenu: true,
            updateSanctuarySubmenu: true,
            dustUpdate: true,
            questUpdate: true,
            starCreationAmount: 1,
            formationUpdate: true,
            questProgressUpdate: true,
            soulUpdate: true,
            worldSwap: true,
            swapPages: false,
        }

        this.uiState = {
            isPlayerMenuActive: false,
            activePlayerSubmenu: "none",
            isTileMenuActive: false,
            activeTileSubmenu: "none"
        };
      

        this.worldHandler = new worldHandler();
        this.worldHandler.setupDefaultWorld();

        //console.log(this.worldHandler.getActiveWorld());
        //if (this.worldHandler.getActiveWorld() !== null) {
        this.currentTile = this.worldHandler.getActiveWorld().getTile(this.map.centerX, this.map.centerY);
        //}

        this.soulHandler = new soulHandler();
        
        this.spellHandler = new spellHandler();

        this.huntingHandler = new huntingHandler(this);


        this.elementNames = ["fire", "earth", "light", "wind", "cold", "water", "lightning", "dark"];
        this.formationNames = ['stars', 'paths', 'maps', 'constellations'];
    }


    swapWorld(worldInfo) {
        if (!worldInfo || !worldInfo.seed) return;
        const worldId = this.worldHandler.addWorld(worldInfo.seed, worldInfo.elements, worldInfo.tier);
        this.worldHandler.setActiveWorld(worldId);
        
        this.uiInfo.worldSwap = true;
        this.moveCenter(0, 0);
        this.currentTile = this.worldHandler.getActiveWorld().getTile(0, 0);
        
    } 

    /**
     * Core resource verification helper used by active battle processors
     */
    deductPlayerMP(amount) {
        const cost = new Decimal(amount || 0);
        if (this.player.stats.magicPower.gte(cost)) {
            this.player.stats.magicPower = this.player.stats.magicPower.minus(cost);
            return true;
        }
        return false;
    }

    
    //helpers for actions
    calculateActionDuration(action) {
        this.actions[action].duration = this.actions[action].baseDuration
        //console.log(this.actions[action].duration);
    }

    calculateActionProgressPercentage(action) {
        let percent;
        percent = this.actions[action].progress / this.actions[action].duration;
        percent = percent * 1000;
        percent = Math.trunc(percent) / 10
        return percent;
    }


    async claimQuestReward(questId) {
        const currentWorldHandler = this.worldHandler.getActiveWorld();
        
        const result = await currentWorldHandler.claimQuestReward(questId);
        

        if (!result) {
            console.warn("Claim blocked by handler. Aborting game state updates.");
            return null; 
        }

        try {

            if (result.data) {
                console.log("Server spells received:", result.data);     
                this.spellHandler.addSpellPacket(result.data);
                this.uiInfo.newShard = true;
                this.uiInfo.questUpdate = true;
            }
        } catch (inventoryError) {
            console.error("Failed to add spells to player object:", inventoryError);
        }
        
        return result;
    }


    //Formations
    //Converts selected elements dust into stars
    //amount of dust required and stars created is dependent on how many stars the player already has 
    // and how many are being created
    createStars(amount) {
        if (this.player.elements[this.player.currentFormationElement]) {
            const elementName = this.player.currentFormationElement;
            if (amount === 'max') {
                const purchaseInfo = this.getMaxStarsPurchasable(elementName);
                const amountToBuy = purchaseInfo.maxStars;
                const totalCost = purchaseInfo.cost;
                
                if (amountToBuy === 0) {
                    console.log("Can't afford any stars!");
                    return;
                } else {
                    this.player.elements[elementName].dust = this.player.elements[elementName].dust.minus(totalCost);
                    this.player.elements[elementName].purchasedStars += amountToBuy;
                    this.player.elements[elementName].formations.stars += amountToBuy;

                    // UI update
                    this.uiInfo.dustUpdate = true; 
                    console.log(`Successfully bought ${amountToBuy} stars for ${totalCost.toString()} dust!`);
                }
                
            } else if (amount === 1) {

                let cost = this.getStarCost(elementName);
                let tempDust = new Decimal(this.player.elements[elementName].dust);

                if (tempDust.gte(cost)) {
                    console.log("created 1 star");
                    this.player.elements[elementName].dust = this.player.elements[elementName].dust.minus(cost).round();
                    this.player.elements[elementName].purchasedStars++;
                    this.player.elements[elementName].formations.stars++;  
                } else {
                    console.log("not enough dust")
                }              
            } else {
                console.log("error: undefined amount of stars being created");
            }
        }

        this.uiInfo.formationUpdate = true;
    }

    //Recursively compounds the players current stars and formations into higher tiers
    upgradeFormations() {
        if (this.player.elements[this.player.currentFormationElement]) {
            const elementName = this.player.currentFormationElement;
            const formations = this.player.elements[elementName].formations;

            for (let i = 0; i < this.formationNames.length - 1; i++) {
                let checkFormation = this.formationNames[i];

                if (formations[checkFormation] >= 8) {
                    let upgradeFormation = this.formationNames[i + 1];

                    let amountUpgraded = Math.floor(formations[checkFormation] / 8);
                    
                    formations[checkFormation] -= (amountUpgraded * 8);
                    formations[upgradeFormation] += amountUpgraded;

                    console.log(`upgraded ${amountUpgraded * 8} ${checkFormation} to ${amountUpgraded} ${upgradeFormation}`);
                }
            }
        } else {
            console.log("error getting formations for upgrading")
        }

        this.uiInfo.formationUpdate = true;
        //console.log(this.getStarCost(262143).toString());
    }

    getStarCost(elementName) {
        let currentStars = this.player.elements[elementName].purchasedStars;
        const bracket = Math.floor(currentStars / 8);
        const stepInBracket = (currentStars % 8) + 1;
        let bracketMultiplier = new Decimal(8).pow((bracket * 2) + 1);
        return bracketMultiplier.times(stepInBracket);
    }

    //Takes currentStars and currentDust of an element and calculates how many stars
    // the player can purchase
    getMaxStarsPurchasable(elementName) {
        let currentStars = this.player.elements[elementName].purchasedStars;
        let tempDust = new Decimal(this.player.elements[elementName].dust);
        let sumDust = new Decimal(0);
        let totalStarsBought = 0;

        // --- Step 1: Buy what we can in the CURRENT messy bracket ---
        let stepInBracket = (currentStars % 8) + 1; 
        let maxLeftInBracket = 9 - stepInBracket;   
        
        let bracket = Math.floor(currentStars / 8);
        let bracketMultiplier = new Decimal(8).pow((bracket * 2) + 1);

        let boughtInBracket = this.solveQuadraticStars(stepInBracket, tempDust, bracketMultiplier);
        if (boughtInBracket > maxLeftInBracket) boughtInBracket = maxLeftInBracket;

        if (boughtInBracket > 0) {
            let cost = bracketMultiplier.times(boughtInBracket).times(2 * stepInBracket + boughtInBracket - 1).div(2).round(); 
            tempDust = tempDust.minus(cost);
            sumDust = sumDust.plus(cost);
            currentStars += boughtInBracket;
            totalStarsBought += boughtInBracket;
        }

        // --- Step 2: Keep looping through fresh brackets until we run out of dust ---
        // Change 'if' to a 'while' loop, and remove the hard stop constraint
        while (tempDust.gt(0) && (currentStars % 8) === 0) {
            let nextBracket = Math.floor(currentStars / 8);
            let nextMultiplier = new Decimal(8).pow((nextBracket * 2) + 1);
            
            let boughtInNext = this.solveQuadraticStars(1, tempDust, nextMultiplier);
            if (boughtInNext > 8) boughtInNext = 8; 
            
            if (boughtInNext > 0) {
                let costNext = nextMultiplier.times(boughtInNext).times(2 * 1 + boughtInNext - 1).div(2).round();
                tempDust = tempDust.minus(costNext);
                sumDust = sumDust.plus(costNext);
                currentStars += boughtInNext;
                totalStarsBought += boughtInNext;
            }

            // CRITICAL LOOP BREAK: If they couldn't even afford 8 stars in this bracket,
            // it means they don't have enough dust to clear it. Break to prevent an infinite loop.
            if (boughtInNext < 8) {
                break;
            }
        }

        return {
            maxStars: totalStarsBought,
            cost: sumDust
        };
    }

    // Helper method to solve: k^2 + (2s - 1)k - (2 * dust / multiplier) = 0
    solveQuadraticStars(s, dust, multiplier) {
        let allowedDustCost = dust.div(multiplier);
        if (allowedDustCost.lte(0)) return 0;
        let b = 2 * s - 1;
        let c = allowedDustCost.times(2);
        let discriminant = new Decimal(b * b).plus(c.times(4));
        let sqrtDisc = discriminant.sqrt();
        let k = sqrtDisc.minus(b).div(2).floor();      
        return Math.max(0, k.toNumber());
    }


    getCurrentTier(elementName) {
        let tierString;

        function convertToRomanTier(number) {
            const romanNumerals = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII"];
            const index = Math.min(number, 8) - 1;
            return romanNumerals[index] || "I";
        }

        if (this.player.elements[elementName]) {
            const formations = this.player.elements[elementName].formations;
           
            let division;

            if (formations[this.formationNames[3]] > 0) {
                tierString = "Advanced "
                division = 3;
            } else if (formations[this.formationNames[2]] > 0) {
               tierString = "Intermediate " 
               division = 2;
            } else if(formations[this.formationNames[1]] > 0) {
                tierString = "Novice "
                division = 1;
            } else if (formations[this.formationNames[0]] > 0) {
                tierString = "Beginner "
                division = 0;
            } else {
                tierString = 'Noob '
                division = 0;
            }

            tierString += convertToRomanTier(formations[this.formationNames[division]]);
            this.player.elements[elementName].tier = division;
        }

        return tierString

    }




    //Cultivation
    startCultivation(elementName, soulTier, mpAmount) {
        if (!elementName) return;
        
        const activeData = this.actions.cultivation[elementName];
        if (activeData.isActive) {
            return;
        }

        const safeSoulTier = soulTier || 0; 

        const mpCost = new Decimal(mpAmount || 0);
        if (!this.player.stats.magicPower.gte(mpCost)) {
            return;
        }

        if (safeSoulTier > 0) {
            if (!this.soulHandler.hasEnoughSouls(elementName, safeSoulTier, 1)) {
                return;
            }
        }

      
        this.incrementMagicPower(mpCost.negate()); // Subtract MP
        
        // ONLY spend the soul if they are using one
        if (safeSoulTier > 0) {
            this.soulHandler.spendSouls(elementName, safeSoulTier, 1);
        }

        // 3. Calculate expected reward and start
        console.log("start");
        const expectedDust = this.calculateDustGain(safeSoulTier, mpCost);
        
        activeData.dustGain = expectedDust; 
        activeData.mpUsed = mpCost;
        activeData.currentSoulTier = safeSoulTier; 
        activeData.progress = 0;
        activeData.isActive = true;

        this.uiInfo.dustUpdate = true;
    }

    calculateDustGain(soulTier, mpCost) {
        console.log("start");
        // 1. Safety checks: Ensure we always have usable numbers even if called incorrectly
        const safeTier = soulTier || 0;
        const safeMp = new Decimal(mpCost || 0);

        // 2. Calculate Base
        let baseDust = new Decimal(1);
        if (safeTier > 0) {
            baseDust = new Decimal(10).pow(safeTier);
        }
        
        // 3. Calculate Multiplier
        const mpMultiplier = safeMp.div(100).add(1); 
        
        // 4. Calculate Final Result (using .floor() instead of .round() for library safety)
        const finalDust = baseDust.times(mpMultiplier).floor();

        // DEBUG: This will print to your console exactly what math is happening
        console.log(`[Dust Calc] Tier: ${safeTier} | MP: ${safeMp.toString()} | Base: ${baseDust.toString()} | Mult: ${mpMultiplier.toString()} | Final: ${finalDust.toString()}`);

        return finalDust;
    }
    
    setCultivationMPUsed(elementName, amount) {
        this.actions.cultivation[elementName].mpUsed = new Decimal(amount);
    }

    getCurrentCultivationProgressPercentage() {
        let percent;
        percent = this.actions.cultivation[this.player.currentCultivationElement].progress /
         this.actions.cultivation[this.player.currentCultivationElement].duration;
        percent = percent * 1000;
        percent = Math.trunc(percent) / 10
        return percent;
    }

    cultivationComplete(elementName) {
        const activeData = this.actions.cultivation[elementName];

        this.incrementDust(activeData.dustGain, elementName);

        activeData.isActive = false;
        activeData.progress = 0;
        activeData.dustGain = new Decimal(0);
        activeData.currentSoulTier = null;
    }

    getElementDust(elementName) {
        return this.player.elements[elementName].dust
    }

    getElementDustString(elementName) {
        const dust = this.getElementDust(elementName);

        
        return this.formatVolume(dust);

    }

    formatVolume(decimalValue) {
        const num = new Decimal(decimalValue);

        if (num.exponent >= 16) {
            const fixedMantissa = num.mantissa.toFixed(5);
            return `${fixedMantissa}e${num.exponent}`;
        }

        if (num.exponent >= 3) {
            return Math.floor(num.toNumber()).toLocaleString();
        }

        return parseFloat(num.toNumber().toFixed(1)).toString();
    }

    //value: decimal
    incrementDust(value, elementName) {
        let currentDust = this.player.elements[elementName].dust;
        const safeValue = new Decimal(value || 0);
        
        this.player.elements[elementName].dust = currentDust.add(safeValue);
        this.uiInfo.dustUpdate = true;
    }





    //Awakening
    startAwakening() {
        if (!this.actions.awakening.isActive) {
            const currentElementCount = Object.keys(this.player.elements).length;
            if (currentElementCount >= 3) {
                console.log("error max of 3 elements reached");
                return; 
            }

            const availablePool = Object.values(this.elementNames).filter(
                elementName => !this.player.elements[elementName]
            );

            if (availablePool.length === 0) {
                console.log("error no available elements to unlock");
                return;
            }

            const randomIndex = Math.floor(Math.random() * availablePool.length);
            const chosenElement = availablePool[randomIndex];

 
            this.actions.awakening.isActive = true;
            this.actions.awakening.progress = 0;
            this.actions.awakening.targetElement = chosenElement; 

            this.calculateActionDuration('awakening');
        }
    }

    awakeningComplete() {
        this.actions.awakening.isActive = false;
        this.actions.awakening.progress = 0;
        
        const elementToGenerate = this.actions.awakening.targetElement;
        this.awakenNewElement(elementToGenerate);
        
        this.actions.awakening.targetElement = null; 
    }

    awakenNewElement(chosenElement) {
        if (!chosenElement) {
            console.log("error: no element target provided for generation");
            return;
        }
        
        this.player.elements[chosenElement] = {
            name: `${chosenElement}`,
            dust: new Decimal(0),
            tier: 0,
            purchasedStars: 0,
            formations: {  
                stars: 0,
                paths: 0,
                maps: 0,
                constellations: 0
            }
        };

        this.actions.cultivation[chosenElement] =  {
            isActive: false,
            progress: 0,
            duration: 1000,
            baseDuration: 1000, 
            soulsUsed: {},
            mpUsed: new Decimal(0),
            dustGain: new Decimal(0),
            currentSoulTier: null
        }
        
        

        Object.keys(this.uiInfo.newElement).forEach(key => {
            this.uiInfo.newElement[key] = true;
        })
    }


    //Meditation
    doMeditation(start) {
        this.calculateMPGain();
        this.incrementMagicPower(this.actions.meditation.mpGain);
    }

    calculateMPGain() {
        let gain = new Decimal(0)
        
        let gainAmount = this.currentTile.magnitude > 0 ? this.currentTile.magnitude : 1;

        gain = gain.add(gainAmount)
        //get info for current tile

        //calculate current mp gain for meditation
        //console.log(gain.toFixed(2));
        this.actions.meditation.mpGain = gain;
        this.uiInfo.updateSanctuarySubmenu = true;
    }



     //passed a Decimal
    incrementMagicPower(value) {
        let currentMP = this.player.stats.magicPower;
        this.player.stats.magicPower = currentMP.add(value);
    }

   

    //Map
    moveCenter(newX, newY) {
        this.map.centerX = newX;
        this.map.centerY = newY;

        network.sendMove(newX, newY);
        
        this.currentTile = this.worldHandler.getActiveWorld().getTile(this.map.centerX, this.map.centerY);
        this.huntingHandler.onTileChanged();

        Object.keys(this.uiInfo.hasMoved).forEach(key => {
            this.uiInfo.hasMoved[key] = true;
        })

        this.calculateMPGain();
    }

    
    //sets gameState to a default state
    reset() {
        this.init();

        this.isPlayerSaving = false;
        
        //ui update
        this.uiInfo.dustUpdate = true;
        this.uiInfo.formationUpdate = true;

        this.uiState = {
            isPlayerMenuActive: false,
            activePlayerSubmenu: "none",
            isTileMenuActive: false,
            activeTileSubmenu: "none"
        };
    }

    loadFromJSON(parsedData) {
        if (parsedData.map) this.map = parsedData.map;
        if (parsedData.uiInfo) this.uiInfo = parsedData.uiInfo;
        this.player.currentCultivationElement = parsedData.player?.currentCultivationElement || null;
        this.player.currentFormationElement = parsedData.player?.currentFormationElement || null;


        if (parsedData.uiState) {
            this.uiState = {
                ...this.uiState,
                ...parsedData.uiState
            };
        }

        //Magic Power
        if (parsedData.player?.stats?.magicPower) {
            this.player.stats.magicPower = new Decimal(parsedData.player.stats.magicPower);
        }

        //Elements and Dust
        if (parsedData.player?.elements) {
            for (const [elementName, elementData] of Object.entries(parsedData.player.elements)) {
                this.player.elements[elementName] = {
                    name: elementData.name,
                    tier: elementData.tier,
                    purchasedStars: elementData.purchasedStars || 0,
                    formations: elementData.formations || { stars: 0, paths: 0, maps: 0, constellations: 0 },
                    
                    //rewrapping dust
                    dust: new Decimal(elementData.dust || 0)
                };
            }
        }

        //Actions
        if (parsedData.actions) {
            //meditation
            if (parsedData.actions.meditation) {
                this.actions.meditation = parsedData.actions.meditation;
                this.actions.meditation.mpGain = new Decimal(parsedData.actions.meditation.mpGain || 0);
            }
            
            //awakening
            if (parsedData.actions.awakening) {
                this.actions.awakening = parsedData.actions.awakening;
            }

            //cultivation
            if (parsedData.actions.cultivation) {
                for (const [elementName, cultData] of Object.entries(parsedData.actions.cultivation)) {
                    this.actions.cultivation[elementName] = {
                        ...cultData,
                        mpUsed: new Decimal(cultData.mpUsed || 0)
                    };
                }
            }
        }

        // Load tile/world data
        if (parsedData.savedWorlds) {
            this.worldHandler.loadFromData(parsedData.savedWorlds);    
        }

        if (parsedData.savedSouls) {
            this.soulHandler.loadFromData(parsedData.savedSouls);
        }

        // Ensure an active world exists even if save data was empty
        let activeWorld = this.worldHandler.getActiveWorld();
        if (!activeWorld) {
            this.worldHandler.addWorld("-1--2", ["fire", "dark"], 4);
            activeWorld = this.worldHandler.getActiveWorld();
        }

        if (activeWorld) {
            this.currentTile = activeWorld.getTile(this.map.centerX, this.map.centerY);
        }

        if (parsedData.savedSpells) {
            this.spellHandler.loadFromData(parsedData.savedSpells);
        }
    
        if (parsedData.savedHuntingData) {
            this.huntingHandler.loadFromData(parsedData.savedHuntingData)
        }

        //Force UI Refresh
        Object.keys(this.uiInfo.newElement).forEach(key => {
            this.uiInfo.newElement[key] = true;
        });

        Object.keys(this.uiInfo.hasMoved).forEach(key => {
            this.uiInfo.hasMoved[key] = true;
        })

        
        this.uiInfo.dustUpdate = true;
        this.uiInfo.formationUpdate = true;
        this.uiInfo.updateHuntingSubmenu = true;
        this.uiInfo.updateSanctuarySubmenu = true;
        this.uiInfo.questUpdate = true;
    }

    update(dt) {
        // //meditation timer
        // if (this.actions.meditation.isActive) {
        //     this.actions.meditation.progress += dt;

        //     if (this.actions.meditation.progress >= this.actions.meditation.duration) {
        //         this.meditationComplete();
        //     }
        // }

        //awakening timer
        if (this.actions.awakening.isActive) {
            this.actions.awakening.progress += dt;

            if (this.actions.awakening.progress >= this.actions.awakening.duration) {
                this.awakeningComplete();
            }
        }

        //cultivation timers
        
            
        const activeCultivation = this.actions.cultivation;

        if (activeCultivation) {
            for (const [elementId, data] of Object.entries(activeCultivation)) { 
                if (data.isActive) {
                    data.progress += dt;

                    if (data.progress >= data.duration) {
                        this.cultivationComplete(elementId);
                    }
                }
            }
        }

        this.huntingHandler.update(dt);
    }

}




// export const playerState = {
//     magicPower: 0,
//     elements: []
// }

// export function incrementMagicPower(amount) {
//     playerState.magicPower += amount;
// }


// magicPower (large number)
// souls, 2d array, each soul has a element and tier (1-6)




// export const mapState = { 
//     currentTile: null,
//     gridSize: 5,
//     xPos: 0,
//     yPos: 0
// }


// //structure of each tile
// const tileState = {
//     xPos: 0,
//     yPos: 0,
//     sanctuaryLevel: 4,
//     sanctuaryBoost: 1.4,
//     element: "wind",
//     tiers: [
//         {level: 1, capacityMax: 500, capacity: 400},
//         {level: 5, capacityMax: 8000, capacity: 2626},
//         {level: 80, capacityMax: 260000, capacity: 0}
//     ],
//     quests: [
//         {level: 1, type: "hunting-elemental", location: [-1, -1], amount: 500, reward: 1000},
//         {level: 4, type: "training", location: [-1, -1], amount: 500, reward: 4000},
//         {level: 18, type: "hunting-locational", location: [4, 6], amount: 500, reward: 18000}
//     ]
// }

// const spellStructure = {
//     element: "Fire",
//     tier: 4,
//     power: 5959 //could be a function call like calculateSpellPower()

// }